import React, { memo } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const MenuItem = ({
                    item,
                    pathname
                  }) => {
  const activeClassName = pathname === `/${item.url}` ? "active" : "";

  return (
    <li className="nav-item">
      <Link
        className={`nav-link ${activeClassName}`}
        to={`/${item.url}`}
      >
        <FontAwesomeIcon icon={item.icon} title={item.title}/>
        <span className="ml-2">{item.title}</span>
      </Link>
    </li>
  );
};

export default memo(MenuItem);



// WEBPACK FOOTER //
// ./src/views/layout/components/MenuItem.js